import React, { Component } from 'react';
import ReactTable from 'react-table';
import debounce from 'lodash.debounce';
import Pagination from '@getgo/chameleon-react/dist/Pagination';
import './SessionsTable.css';
import { connect } from 'react-redux';
import { sessionsTableSkeletonScreen } from '../../../../SkeletonScreens/SkeletonScreen';
import { actions } from '../../../../Reducks/AdminSessions/index';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { CHECKBOX, VALUE_ADD } from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { HeaderSortComponent } from '../../../../Scss/Custom/ReactTable/HeaderSortComponent';
import PropTypes from 'prop-types';
import { denormalizeSessions } from '../../../../Reducks/Sessions/SessionsUtils';
import {
  attendanceRateFormatter,
  dateFormatter,
  dateSorter,
  dayFormatter,
  daySorter,
  getSessionsData,
  startTimeFormatter,
  startTimeSorter
} from '../../../../Utils/TableUtil';
import { NavLink } from 'react-router-dom';
import SimpleSearchBox from '../../../../Components/SearchBox/SimpleSearchBox';
import { SESSION_PAGE_COUNT, SessionsTableVisibleColumns } from '../../../../Utils/Constants';
import { toggleElement } from '../../../../Utils/ArrayUtils';
import { getSessionsTableColumnOptions } from '../../../../Components/CheckedMenu/CheckedMenuItemsHelper';
import CheckedMenu from '../../../../Components/CheckedMenu/CheckedMenu';

export class SessionsTable extends Component {
  static propTypes = {
    uniqueId: PropTypes.string.isRequired,
    focusedSessionKeyInTable: PropTypes.string,
    focusSessionInChart: PropTypes.func,
    includeEngagementColumns: PropTypes.bool,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    isBig: PropTypes.bool,
    sessions: PropTypes.object,
    sessionData: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: [
        SessionsTableVisibleColumns.ATTENDANCE_RATE,
        SessionsTableVisibleColumns.DAY,
        SessionsTableVisibleColumns.DATE,
        SessionsTableVisibleColumns.ATTENDANCE_RATE,
        SessionsTableVisibleColumns.REGISTRANT_COUNT,
        SessionsTableVisibleColumns.START_TIME,
        SessionsTableVisibleColumns.ATTENDEE_COUNT
      ],
      searchText: ''
    };
    this._webinarNameRefs = new Map();
  }

  onClickHandler = updateId =>
    this.setState(prevState => ({ visibleColumns: toggleElement(updateId, prevState.visibleColumns) }));

  componentDidUpdate(prevProps) {
    this.scrollToSessionInTable(
      prevProps ? prevProps.focusedSessionKeyInTable : null,
      this.props.focusedSessionKeyInTable
    );
    if (this.props.modalFlag !== prevProps.modalFlag) {
      const tableId = this.props.modalFlag ? 'sessionsTableInGenerateReports' : 'sesssionsTableInOverview';
      this.props.passingTableId(tableId);
    }
  }

  componentDidMount() {
    if (this.props && this.props.passingTableId) {
      const tableId = this.props.modalFlag ? 'sessionsTableInGenerateReports' : 'sesssionsTableInOverview';
      this.props.passingTableId(tableId);
    }
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  render() {
    const sessions = this.props.sessionData;
    const { fetching, filtering } = this.props.sessions;
    const focusSessionInChart = this.props.focusSessionInChart;
    const filteredSessions = denormalizeSessions(sessions.filteredKeys, sessions.byKey);
    const detailsMenu = getSessionsTableColumnOptions().map(item => {
      return {
        onClick: () => this.onClickHandler(item.id),
        text: item.title,
        id: item.id,
        checked: this.state.visibleColumns.includes(item.id)
      };
    });

    return (
      <div className="sessionsTableSection">
        {this.getSearchBar(detailsMenu)}
        {fetching || filtering
          ? sessionsTableSkeletonScreen()
          : this.getSessionsTable(filteredSessions, focusSessionInChart)}
      </div>
    );
  }

  getSelectedPageSessions = page => {
    const { user } = this.props.reduced_user;
    const { fromTime, toTime, creators, registrantRange, attendeeRange } = this.props.sessions.filter;
    this.props.getSessions(
      user.accountKey,
      fromTime,
      toTime,
      creators,
      registrantRange,
      attendeeRange,
      this.state.searchText,
      page,
      SESSION_PAGE_COUNT,
      false
    );
  };

  fetchPage = (page = 1) => {
    this.getSelectedPageSessions(page - 1);
  };

  fetchPageDebounced = debounce(this.fetchPage, 500);

  getSessionsTable = (filteredSessions, focusSessionInChart) => {
    const { pagination, sessionsFetching } = this.props.sessions;
    const nextDisabled = typeof pagination.next !== 'number';
    const previousDisabled = typeof pagination.previous !== 'number';
    const showPagination = !(nextDisabled && previousDisabled);
    return (
      <div>
        <ReactTable
          keyField="sessionKey"
          data={getSessionsData(filteredSessions)}
          columns={this.getColumns()}
          defaultPageSize={filteredSessions.length}
          minRows={5}
          loading={sessionsFetching}
          style={{ height: '270px' }}
          showPagination={false}
          className="-highlight"
          defaultSorted={[{ id: 'date', desc: true }]}
          getTrProps={(state, rowInfo) => {
            return {
              onMouseEnter: () => focusSessionInChart(rowInfo.original.sessionKey),
              onMouseLeave: () => focusSessionInChart(null)
            };
          }}
        />
        {showPagination && (
          <div className="pagination">
            <Pagination
              disableLast={false}
              key="event-pagination"
              lastPage={pagination.pageCount}
              nextDisabled={nextDisabled}
              onNextSelected={() => this.getSelectedPageSessions(pagination.next)}
              onPageSelected={this.fetchPage}
              onPreviousSelected={() => this.getSelectedPageSessions(pagination.previous)}
              pageIndex={pagination.page + 1}
              previousDisabled={previousDisabled}
            />
          </div>
        )}
      </div>
    );
  };

  getSearchBar = detailsMenu => {
    const { mixpanelData } = this.props;
    const { t } = this.context;
    const { isBig, uniqueId } = this.props;
    return (
      <div className="searchBoxContainer">
        <SimpleSearchBox
          searchString={this.state.searchText}
          placeHolder={t('sessions.search')}
          onSearchInputChange={this.handleSearch}
          mixpanelData={mixpanelData}
        />
        <CheckedMenu
          menuKey={`sessionsTableManageColumns_${uniqueId}`}
          detailsMenu={detailsMenu}
          buttonName={t('sessionDetails.manageColumns')}
          isBig={isBig}
        />
      </div>
    );
  };

  handleSearch = value => {
    this.setState({ searchText: value.trim() }, this.fetchPageDebounced);
  };

  getColumns = () => {
    const { t } = this.context;
    const { filteredSelectedSessionKeys, filteredKeys } = this.props.sessionData;
    const { includeEngagementColumns = false } = this.props;

    const checkBoxColumn = {
      accessor: '',
      Header: this.checkBoxHeaderFormatter(filteredKeys.length, filteredSelectedSessionKeys.length),
      Cell: this.checkBoxCellFormatter,
      sortable: false,
      width: 67,
      resizable: false,
      className: 'stickyCheckBox',
      headerClassName: 'stickyCheckBox',
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    };
    const nameColumn = {
      accessor: 'name',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.name')} />,
      Cell: this.webinarNameFormatter,
      className: 'stickyName',
      headerClassName: 'stickyName',
      minWidth: 150
    };
    const organizerColumn = {
      accessor: 'organizerName',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.organizers')} />,
      Cell: this.organizerFormatter,
      minWidth: 100
    };
    const dayColumn = {
      accessor: 'day',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.day')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.DAY),
      Cell: dayFormatter,
      sortMethod: daySorter,
      width: 100
    };
    const dateColumn = {
      accessor: 'date',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.date')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.DATE),
      Cell: dateFormatter,
      sortMethod: dateSorter
    };
    const startTimeColumn = {
      accessor: 'startTime',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.startTime')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.START_TIME),
      Cell: startTimeFormatter,
      sortMethod: startTimeSorter
    };
    const registrantCountColumn = {
      accessor: 'registrants',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.registrants')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.REGISTRANT_COUNT)
    };
    const attendeeCountColumn = {
      accessor: 'attendees',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.attendees')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.ATTENDEE_COUNT)
    };
    const attendanceRateColumn = {
      accessor: 'attendanceRate',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.attendanceRate')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.ATTENDANCE_RATE),
      Cell: attendanceRateFormatter
    };
    const engagementCountColumn = {
      accessor: 'engagementCount',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.engagementCount')} />
    };
    const qAndACountColumn = {
      accessor: 'qAndAResponseCount',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.qAndAResponses')} />
    };
    const pollResponseCountColumn = {
      accessor: 'pollResponses',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.pollResponses')} />
    };
    const surveyResponseCountColumn = {
      accessor: 'surveyResponses',
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.surveyResponses')} />
    };

    const defaultColumns = [
      checkBoxColumn,
      nameColumn,
      organizerColumn,
      dayColumn,
      dateColumn,
      startTimeColumn,
      registrantCountColumn,
      attendeeCountColumn,
      attendanceRateColumn
    ];

    const extraColumns = [engagementCountColumn, qAndACountColumn, pollResponseCountColumn, surveyResponseCountColumn];
    return includeEngagementColumns ? [...defaultColumns, ...extraColumns] : defaultColumns;
  };

  checkBoxCellFormatter = ({ original }) => {
    return (
      <input
        type="checkbox"
        ref={c => this._webinarNameRefs.set(original.sessionKey, c)}
        checked={this.props.sessionData.filteredSelectedSessionKeys.includes(original.sessionKey)}
        onChange={e => {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
          if (this.props.mixpanelData.reportType) {
            trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
          }
          this.props.toggleSession(original.sessionKey, e.target.checked, this.props.uniqueId);
        }}
      />
    );
  };
  webinarNameFormatter = ({ original }) => {
    const { user } = this.props.reduced_user;
    return (
      <NavLink to={`/analytics/accounts/${user.accountKey}/sessions/${original.sessionKey}`}>{original.name}</NavLink>
    );
  };
  organizerFormatter = ({ original }) => {
    return (
      <div>
        <div>{original.organizerName}</div>
        <div className="organizerEmail">{original.organizerEmail}</div>
      </div>
    );
  };

  checkBoxHeaderFormatter = (totalCount, selectedCount) => {
    const checked = selectedCount !== 0;
    const isIntermediate = selectedCount !== 0 && selectedCount !== totalCount;
    const onCheck = e => {
      trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
      if (this.props.mixpanelData.reportType) {
        trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
      }
      this.props.toggleAllSessions(e.target.checked, this.props.uniqueId);
    };
    const intermediate = input => {
      if (input) {
        input.indeterminate = isIntermediate;
      }
    };
    return <input type="checkbox" ref={intermediate} checked={checked} onChange={onCheck} />;
  };

  scrollToSessionInTable = (previousSessionKey, newSessionKey) => {
    if (newSessionKey) {
      const node = this._webinarNameRefs.get(newSessionKey);
      try {
        const row = node.parentElement.parentElement.parentElement;
        const tableBodyNode = row.parentElement;
        tableBodyNode.scrollTop = row.offsetTop - 45;
        const { scrollX, scrollY } = window;
        node.focus({ preventScroll: true });
        window.scrollTo(scrollX, scrollY);

        return this;
      } catch (e) {}
    } else if (previousSessionKey) {
      const node = this._webinarNameRefs.get(previousSessionKey);
      if (node) {
        node.blur();
      }
    }
  };
}

export default connect(
  state => ({
    sessions: state.reduced_admin_sessions,
    modalFlag: state.reduced_reports.isGenerateReportOpen,
    reduced_user: state.reduced_user
  }),
  {
    getSessions: actions.getAdminSessions,
    toggleSession: actions.toggleAdminSession,
    toggleAllSessions: actions.toggleAllAdminSessions,
    passingTableId: actions.postAdminTableId
  }
)(SessionsTable);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/Sessions/Table/SessionsTable.js